<template>
    <div>
        <div v-if="!showCreateForm" class="mb-5">
            <span @click="onAddReminder"><add-button :buttonText="$t('addNewMedicationReminder')" showTextOnMobile></add-button></span>
        </div>
        <medication-reminder-form v-if="showCreateForm" :formData="formData" :medicationCode="medicationCode" @onShowReminderMenu="onShowReminderMenu"></medication-reminder-form>
        <b-row v-if="!showCreateForm" class="row-gap">
            <medication-reminder-block v-for="(item, index) in reminders" :key="`reminderBlock${index}`" @onEdit="loadFormData($event)" @onDelete="onShowReminderMenu" @onRefreshMedications="onShowReminderMenu" :id="item.id" :reminderType="item.reminderType" :medicationName="item.medication.name" :tabletsLeft="item.tabletsReminder.left" :notes="item.notes"
            :interval="item.interval" :cyclic="item.cyclic" :severalTimesWeek="item.severalTimesWeek" :severalTimesDay="item.severalTimesDay" :tabletsReminderSent="item.tabletsReminder.reminderSent"></medication-reminder-block>
        </b-row>
    </div>
</template>

<script>
import medicationReminderRepository from '@/repositories/MedicationReminderRepository'
import MedicationReminderForm from '@/components/views/clinicHistory/medicationReminder/MedicationReminderForm'
import MedicationReminderBlock from '@/components/views/clinicHistory/medicationReminder/MedicationReminderBlock'
import AddButton from '@/components/base/buttons/AddButton'
import BackButton from '@/components/base/buttons/BackButton'

const MEDICATION_REMINDER_ROUTE_NAME = 'medicationReminder'
const NEW_MEDICATION_REMINDER_ROUTE_NAME = 'newMedicationReminder'
const EDIT_MEDICATION_REMINDER_ROUTE_NAME = 'editMedicationReminder'

export default {
    components: {
        AddButton,
        BackButton,
        MedicationReminderForm,
        MedicationReminderBlock
    },
    data () {
        return {
            showCreateForm: false,
            reminders: [],
            formData: null
        }
    },
    created () {
        window.scrollTo(0, 0)
        if (this.medicationCode) {
            this.showCreateForm = true
        } else {
            this.getMedicationReminders().then(response => {
                if (this.$router.currentRoute.name === NEW_MEDICATION_REMINDER_ROUTE_NAME) {
                    this.$router.push({ name: NEW_MEDICATION_REMINDER_ROUTE_NAME })
                    this.showCreateForm = true
                } else if (this.$router.currentRoute.name === EDIT_MEDICATION_REMINDER_ROUTE_NAME) {
                    this.loadFormData(this.$route.params.id)
                }
            })
        }
    },
    methods: {
        onAddReminder () {
            this.formData = null
            this.$router.push({ name: NEW_MEDICATION_REMINDER_ROUTE_NAME })
        },
        getMedicationReminders () {
            return medicationReminderRepository.getAll().then(response => {
                this.reminders = response.data || []
                if (!this.reminders.length) {
                    this.showCreateForm = true
                }
            })
        },
        onShowReminderMenu () {
            window.scrollTo(0, 0)
            this.getMedicationReminders()
            this.$router.push({ name: MEDICATION_REMINDER_ROUTE_NAME })
            this.showCreateForm = false
        },
        loadFormData (id) {
            this.formData = this.reminders.find(item => item.id === id)
            this.showCreateForm = true
            this.$router.push({ name: EDIT_MEDICATION_REMINDER_ROUTE_NAME, params: { id: id } })
        }
    },
    computed: {
        medicationCode () {
            return this.$route.params.code
        }
    }
}
</script>
    
<style lang="scss" scoped>
.row-gap{
    gap: 2rem
}
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/medicationReminder/MedicationReminderView.vue